// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2-pKF","col":"styles_col__-CAMX"};